import type { DocRecord } from '@serb/shared';

/** Files that are for SERB's own work, not documents of a shipment: blank templates, pricing sheets, Word sources, tracker extracts */
const WORKING = /template|pricing sheet|word source|tracker extract/i;

export const isWorkingFile = (r: Pick<DocRecord, 'type'>) => WORKING.test(r.type);
